export function getInfoFields() {
  return {
    infos: [
      {
        name: "title",
        label: "Titre",
        validation: ANNOUNCEMENT_VALIDATION["title"]
      },
      {
        name: "url",
        label: "Url",
        validation: ANNOUNCEMENT_VALIDATION["url"],
        readOnly: true
      },
      {
        name: "address",
        label: "Adresse",
        as: "geocomplete",
        validation: ANNOUNCEMENT_VALIDATION["address"]
      }
    ],
    contact: [
      {
        name: "saleTrigram",
        label: "Commercial(e)",
        validation: ANNOUNCEMENT_VALIDATION["saleTrigram"],
        readOnly: true
      },
      {
        name: "contactName",
        label: "Nom du contact",
        validation: ANNOUNCEMENT_VALIDATION["companyName"]
      },
      {
        name: "contactPhoneNumber",
        label: "Téléphone",
        validation: ANNOUNCEMENT_VALIDATION["companyPhone"]
      },
      {
        name: "contactEmail",
        label: "Mail",
        validation: ANNOUNCEMENT_VALIDATION["companyMail"]
      }
    ]
  };
}


export const ANNOUNCEMENT_VALIDATION = {
  title: 'required',
  url: 'required',
  address: 'required'
}
